import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import KSUID from 'ksuid';
import styles from './site.module.css';

export function getHoldToken(){
	const cookies = new Cookies();
	const options = { 
        path:'/', 
        sameSite: process.env.NODE_ENV === 'production' ? 'none' : '',
        secure: process.env.NODE_ENV === 'production' 
    };

	if( cookies.cookies.length === 0 ){
		const hold_token = Math.floor(1 + ( Math.random() * 2147483645));
		cookies.set('intix_JSHQ688DNZ', hold_token, options);
		return hold_token;
	} else {
		if( cookies.get('intix_JSHQ688DNZ') === undefined || cookies.get('intix_JSHQ688DNZ') === null ){
			const hold_token = Math.floor(1 + ( Math.random() * 2147483645));
			cookies.set('intix_JSHQ688DNZ', hold_token, options);
			return hold_token;
		} else {
			const hold_token = cookies.get('intix_JSHQ688DNZ');
			return hold_token;
		}
	}
}

export function clearHoldToken(){
	const cookies = new Cookies();
	const options = { 
        path:'/', 
        sameSite: process.env.NODE_ENV === 'production' ? 'none' : '',
        secure: process.env.NODE_ENV === 'production' 
    };

	const hold_token = Math.floor(1 + ( Math.random() * 2147483645));
	cookies.set('intix_JSHQ688DNZ', hold_token, options);
	return hold_token;	
}

export function getSessionCookie(){
	const now = new Date();
	const expiryDate = new Date(now.getTime() + (30 * 60 * 1000)); // 30 minute session
	const session_token = KSUID.randomSync().string;
	const options = { 
        path:'/', 
        sameSite: 'lax',
        secure: process.env.NODE_ENV === 'production',
        expires: expiryDate
    };
	const cookies = new Cookies();

	if( cookies.cookies.length === 0 ){
		cookies.set('intix_sid', session_token, options);
		return true;
	} else {
		if( cookies.get('intix_sid') === undefined || cookies.get('intix_sid') === null ){
			cookies.set('intix_sid', session_token, options);
			return true;
		} else {
			const session_token = cookies.get('intix_sid');
			cookies.set('intix_sid', session_token, options);
			return true;
		}
	}
}

export function getVisitorCookie(){
	const now = new Date();
	const expiryDate = new Date(now.getTime() + (2 * 365 * 24 * 60 * 60 * 1000)); // 2 years
	const visitor_token = KSUID.randomSync().string;
	const options = { 
        path:'/', 
        sameSite: 'lax',
        secure: process.env.NODE_ENV === 'production',
        expires: expiryDate
    };
	const cookies = new Cookies();
	
	if( cookies.cookies.length === 0 ){
		cookies.set('intix_vid', visitor_token, options);
		return true;
	} else {
		if( cookies.get('intix_vid') === undefined || cookies.get('intix_vid') === null ){
			cookies.set('intix_vid', visitor_token, options);
			return true;
		} else {
			const visitor_token = cookies.get('intix_vid');
			cookies.set('intix_vid', visitor_token, options);
			return true;
		}
	}
}

export function getContrast(hexcolor){
	if(hexcolor.slice(0,1) === '#'){ hexcolor = hexcolor.slice(1); }
	if(hexcolor.length === 3){ hexcolor = hexcolor.split('').map(function(hex){ return hex + hex; }).join(''); }

	var r = parseInt(hexcolor.substr(0,2),16);
	var g = parseInt(hexcolor.substr(2,2),16);
	var b = parseInt(hexcolor.substr(4,2),16);

	var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	return (yiq >= 128) ? '#262626' : '#FFFFFF';
}

export function addAffiliateCookie( event_id, affiliate_code ){
	const cookies = new Cookies();
	const options = { path:'/', expires: new Date(new Date().setDate(new Date().getDate() + 30)), sameSite: 'none', secure: true };

	if( cookies.cookies.length === 0 ){
		cookies.set('affiliate_' + event_id, affiliate_code, options);
	} else {
		if( cookies.get('affiliate_' + event_id) === undefined || cookies.get('affiliate_' + event_id) === null ){
			cookies.set('affiliate_' + event_id, affiliate_code, options);
		}
	}
}

export function getStripePublicKey({ country_id }){ 
	if( country_id === 197 || country_id === 33 || country_id === 120 ){
		return process.env.NEXT_PUBLIC_STRIPE_PK_US;
	} else if( country_id === 196 || country_id === 68 || country_id === 72 || country_id === 88 || country_id === 172 ){
		return process.env.NEXT_PUBLIC_STRIPE_PK_GB;
	} else {
		return process.env.NEXT_PUBLIC_STRIPE_PK_AU;
	}
}

export function getPublicURL({ country_id }){ 
	if( country_id === 197 || country_id === 33 || country_id === 120 ){
		return 'https://www.intix.com';
	} else if( country_id === 196 || country_id === 68 || country_id === 72 || country_id === 88 || country_id === 172 ){
		return 'https://www.intix.co.uk';
	} else if( country_id === 133 ){
		return 'https://www.intix.co.nz';
	} else if( country_id === 10 ){
		return 'https://www.intix.com.au';
	} else if( country_id === 178 ){
		return 'https://www.intix.ch';
	} else {
		return 'https://www.intix.com';
	}
}

export function CurrencySymbol({ currency }){
	if( currency == 'AUD' ){ 
		return '$';
	} else if ( currency == 'CHF' ) { 
		return '₣';
	} else if ( currency == 'EUR' ) { 
		return '€';
	} else if ( currency == 'FJD' ) {
		return '$';
	} else if ( currency == 'GBP' ) {
		return '£';
	} else if ( currency == 'NZD' ) {
		return '$';
	} else if ( currency == 'PGK' ) { 
		return 'K';
	} else if ( currency == 'USD' ) {
		return '$';
	} else if ( currency == 'BBD' ) {
		// Barbadian dollar
		return '$';
	} else if ( currency == 'BMD' ) {
		// Bermudian dollar
		return '$';
	} else if ( currency == 'GYD' ) {
		// Guyanese dollar
		return '$';
	} else if ( currency == 'JMD' ) {
		// Jamaican dollar
		return '$';
	} else if ( currency == 'KYD' ) {
		// Cayman Islands dollar
		return '$';
	} else if ( currency == 'TTD' ) {
		// Trinidad & Tobago dollar
		return '$';
	} else if ( currency == 'XCD' ) {
		// Eastern Caribbean dollar
		return '$';
	} else {
		return null;
	}
}

export function CommaFormatted(amount) {
	var delimiter = ","; // replace comma if desired
	if( typeof amount === 'number' ){ amount = amount.toString(); }
	var a = amount.split('.',2)
	var d = a[1];
	var i = parseInt(a[0]);
	if(isNaN(i)) { return ''; }
	var minus = '';
	if(i < 0) { minus = '-'; }
	i = Math.abs(i);
	var n = new String(i);
	var a = [];
	while(n.length > 3) {
		var nn = n.substr(n.length-3);
		a.unshift(nn);
		n = n.substr(0,n.length-3);
	}
	if(n.length > 0) { a.unshift(n); }
	n = a.join(delimiter);
	if(d === undefined || d.length < 1) { amount = n; }
	else { amount = n + '.' + d; }
	amount = minus + amount;
	return amount;
}

export function LogInToSite({ org_id }){
	const baseUrl = process.env.NEXT_PUBLIC_USER_BRANCH === 'prod' ? 'https://auth.intix.com/signin' : 'http://localhost:3001/signin';
	const region = window.location.hostname.includes('intix.com.au') ? 'au' : window.location.hostname.includes('intix.co.nz') ? 'nz' : window.location.hostname.includes('intix.co.uk') ? 'uk' : window.location.hostname.includes('intix.ch') ? 'ch' :'default';
	const url = new URL(baseUrl);
	url.searchParams.set('redirectTo', window.location.href);
	url.searchParams.set('region', region);
	url.searchParams.set('orgId', org_id);
	url.searchParams.set('source', 'tickets');
	window.location.href = url.toString();
}

export function RichResultsOutput({ schema }){ return ( <script id={"rich_results_" + schema.id} key={"rich_results_" + schema.id} type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.structuredJSON) }} /> )}
export const useWindowEvent = (event, callback) => { useEffect(() => { window.addEventListener(event, callback); return () => window.removeEventListener(event, callback); }, [event, callback]); };
export const useGlobalKeyDown = (callback) => { return useWindowEvent("keydown", callback); };
export const useGlobalKeyUp = (callback) => { return useWindowEvent("keyup", callback); };

export function setBodyClass(className){
	// remove other classes
	document.body.className ='';

	// assign new class
	document.body.classList.add(className);
}

export function LoadingTable({ columns, rows }){
	const columns_array = Array.from(Array(columns).keys());
	const rows_array = Array.from(Array(rows).keys());
	return ( <div><div className={styles.hJIkvR}>{columns_array.map((e) => <div key={e} className={styles.dodyiq}></div> )}</div>{rows_array.map((f) => <div key={f} className={styles.hJIkvR}>{columns_array.map((g) => <div key={g} className={styles.bEnsEr}></div> )}</div> )}</div> )
}
